import { EL_STUDENT_CAREERS, EL_STUDENT_CLUSTERS } from 'routes/constants';
import { isNonEmptyArray } from 'utils/arrays';

import { SET_AUDIO_FILES } from 'modules/ElementaryCareers/store/actionTypes';

/**
 * Get the Page Title
 * @param {String} pathname
 * @returns {String} Page Title
 */
export function getPageTitle(pathname) {
  let pageTitle = '';

  if (pathname.includes('clusters')) {
    pageTitle = 'Explore all jobs';
  } else if (pathname.includes('careers')) {
    pageTitle = 'Explore all jobs';
  } else if (pathname.includes('career-quiz')) {
    pageTitle = 'Jobs just for me';
  } else {
    pageTitle = '';
  }

  return pageTitle;
}

/**
 * Finds the Career Page Url
 *
 * @param {Number} currentStudentGrade
 * @returns Career Page Url
 */
export const getCareersPageUrl = currentStudentGrade => {
  if (currentStudentGrade === 1) {
    return EL_STUDENT_CAREERS;
  }
  return EL_STUDENT_CLUSTERS;
};

/**
 * Finds the incomplete quiz
 *
 * @param {Array} quizList
 * @returns
 */

export const findIncompleteQuizIndex = quizList => {
  if (!isNonEmptyArray(quizList)) {
    return -1;
  }

  return quizList.findIndex(
    ({ unansweredQuestionCount }) => unansweredQuestionCount !== 0,
  );
};

/**
 * Finds the label of the Next button in the Result card
 *
 * @param {Number} currentQuestion
 * @param {Number} totalSteps
 * @param {Boolean} isMobile
 * @returns Next Button Label
 */

export const getNextButtonLabel = (
  currentQuestion,
  totalSteps,
  isMobile,
  t,
) => {
  const isLastQuestion = currentQuestion === totalSteps;
  if (isLastQuestion) {
    if (isMobile) {
      return t('ElementaryCareers.NextButton.Finish');
    }
    return t('ElementaryCareers.NextButton.FinishQuiz');
  }

  if (isMobile) {
    return t('ElementaryCareers.NextButton.Next');
  }

  return t('ElementaryCareers.NextButton.GoToNextQuestion');
};

/** Sets the tts enabled status
 *
 *  @param {String} dataTtsId
 *  @param {String} status
 */
export const setTtsEnabledStatus = (dataTtsId, status) => {
  document
    .querySelector(`[data-tts-id="${dataTtsId}"]`)
    ?.setAttribute('data-tts-enabled', status);
};

export const getAudio = ({ id, url, audioFiles, dispatch }) => {
  let audio = audioFiles[id];

  if (!audio) {
    audio = new Audio(url);
    dispatch({
      type: SET_AUDIO_FILES,
      payload: {
        id,
        audio,
      },
    });
  }
  return audio;
};
